import type { Moment } from 'moment'

export enum StandaloneFlightMenu {
  departAirport = 'departAirport',
  arrivalAirport = 'arrivalAirport',
  date = 'date',
  occupants = 'occupants',
}

export interface FlightSearchWidgetFlightItem {
  id: string
  departureAirport?: App.AirportLocation
  arrivalAirport?: App.AirportLocation
  checkinDate?: Moment
  checkoutDate?: Moment
  checkinQuotedPrice?: number
  checkoutQuotedPrice?: number
  showDepartureError?: boolean
  showDestinationError?: boolean
  showTravelDatesError?: boolean
  showSameAirportError?: boolean
}
